/**
 * Mock Database - Stub Exports
 *
 * Mock data has been moved to _archive/mock-data.
 * All data now comes from GraphQL API.
 *
 * This file provides empty stubs for backward compatibility.
 */

// Main database object (empty)
export const MOCK_DATABASE = {
  team: [],
  projects: [],
  tasks: [],
  milestones: [],
  timeEntries: [],
  contacts: [],
  conversations: [],
  messages: [],
  invoices: [],
  customers: [],
  events: [],
  chatSessions: [],
};

// Team
export const MOCK_TEAM_MEMBERS: never[] = [];

// Projects
export const MOCK_PROJECTS: never[] = [];
export const MOCK_TASKLISTS: never[] = [];
export const MOCK_TASKS: never[] = [];
export const MOCK_MILESTONES: never[] = [];
export const MOCK_TIME_ENTRIES: never[] = [];

// Project Content
export const MOCK_PROJECT_MESSAGES: never[] = [];
export const MOCK_PROJECT_FILES: never[] = [];
export const MOCK_PROJECT_LINKS: never[] = [];
export const MOCK_NOTEBOOKS: never[] = [];
export const MOCK_TASK_COMMENTS: never[] = [];
export const MOCK_TASK_CHECKLISTS: never[] = [];
export const MOCK_ACTIVITY_FEED: never[] = [];

// Hub
export const MOCK_CONTACTS: never[] = [];
export const MOCK_CONVERSATIONS: never[] = [];
export const MOCK_MESSAGES: never[] = [];

// Accounting
export const MOCK_ACCOUNTS: never[] = [];
export const MOCK_MOVEMENTS: never[] = [];
export const MOCK_INVOICES: never[] = [];
export const MOCK_CUSTOMERS: never[] = [];
export const MOCK_BANK_ACCOUNTS: never[] = [];
export const MOCK_BANK_TRANSACTIONS: never[] = [];
export const MOCK_DUE_DATES: never[] = [];
export const MOCK_EINVOICES: never[] = [];

// Calendar
export const MOCK_CALENDAR_EVENTS: never[] = [];
export const MOCK_REMINDERS: never[] = [];

// AI
export const MOCK_CHAT_SESSIONS: never[] = [];

// Today's content
export const MOCK_TASKS_TODAY: never[] = [];
export const MOCK_EVENTS_TODAY: never[] = [];
export const MOCK_REMINDERS_TODAY: never[] = [];
export const MOCK_CONVERSATIONS_TODAY: never[] = [];
export const MOCK_MESSAGES_TODAY: never[] = [];
export const MOCK_TIME_ENTRIES_TODAY: never[] = [];
